import React from 'react';

const DemoBehaviorCompassCard = ({ compass }) => {
    return (
        <div className="rounded-[2rem] border border-white/60 bg-white/80 backdrop-blur-xl p-6 md:p-8 shadow-[0_12px_40px_rgba(0,0,0,0.05)] h-full">
            <h2 className="text-2xl md:text-3xl font-black text-[#171717] brand-font">{compass.title}</h2>

            <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
                {compass.pillars.map((pillar, index) => (
                    <div
                        key={pillar.code}
                        className="rounded-[1.75rem] bg-white border border-gray-100 shadow-md p-4 md:p-5"
                    >
                        <div className="flex items-center gap-4">
                            <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${pillar.accent} text-white font-black text-xl flex items-center justify-center shadow-md`}>
                                {pillar.code}
                            </div>
                            <div>
                                <h3 className="text-lg font-black text-[#171717] brand-font">{pillar.title}</h3>
                            </div>
                        </div>
                        <p className="mt-4 text-sm md:text-base text-gray-700 leading-relaxed brand-text">{pillar.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DemoBehaviorCompassCard;
